/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { OrmService, Schema } from '../schema/orm.service';
import { AbstractGenFirestoreService } from '@res/ngg-core';
@Injectable({
  providedIn: 'root',
  deps: [],
})
export class UserFirestoreService extends AbstractGenFirestoreService<Schema, 'users'> {
  constructor() {
    super(inject(OrmService).userCollection);
  }
}
